import React, { Component } from 'react';
import {
    CCol,
    CRow,
    CButton,
    CLabel,
    CForm,
    CModal, CModalBody, CModalHeader, CModalFooter, CContainer, CInput, CTextarea, CFormGroup, CSelect,
    CTooltip,
    CInputCheckbox,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import Select from 'react-select';
import { helps } from 'src/_helpers';
import DateTimePicker from 'react-datetime-picker';
import moment from 'moment';

class EmployeeCheckForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            errors: {},
            project: {},
            positions: [],
            id: '',
            project_id: '',
            employee_id: this.props.employee.employee_id,
            checked_in: 0,
            checkin_time: new Date(),
            checkin_diff: 0,
            checked_out: 0,
            checkout_time: new Date(),
            checkout_diff: 0,
            employee_position: {},
            employee_shift: {},
            check_date: '',
            check_time: '',
            state_text: 'Check-in',
            added_by: this.props.user.id,
            note: '',
            max_date: new Date(),
            housing_id: '',
            check_duration: 0,
            is_overtime: false,

            position_id: '',
            position: {},
            shift_id: '',
            selected_position: {},
            selected_shift: {},
            position_shifts: [],
            default_housing: {},
            default_shift: {},
            curent_date: new Date(),
            found_check: {},
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChangeTime = this.handleChangeTime.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSelectProject = this.handleSelectProject.bind(this);
        this.handleChangeOvertime = this.handleChangeOvertime.bind(this);
    }

    componentDidMount() {
        const { employee, housings, projects, positions } = this.props;
        var curent_date = this.state.curent_date;
        var check_time = new Date(curent_date);
        var state_text = this.state.state_text;
        var shift_start = '';
        var shift_end = '';
        var max_date = new Date(curent_date);
        var min_date = new Date(curent_date);
        min_date = new Date(min_date.setHours(0, 0, 0));

        max_date = new Date(max_date.setDate(curent_date.getDate() + 1));


        if (isNaN(check_time.getTime())) {
            check_time = new Date(curent_date);
        }

        var employee_projects = [];
        if (!helps.isEmpty(projects)) {
            employee_projects = projects.filter((project) => {
                if (project.employees) {
                    let found = helps.getItemFromArr(project.employees, employee.employee_id, 'employee_id');
                    if (!helps.isEmpty(found)) return true;
                    else return false;
                } else {
                    return false;
                }
            })
        }
        //console.log(employee_projects);
        if (!helps.isEmpty(employee_projects)) {
            let project = employee_projects[0];
            let project_positions = positions.filter(position => position.project_id === project.id);
            let project_employee = project.employees.filter(employee => employee.employee_id === employee.employee_id);
            let default_position = !helps.isEmpty(project_employee.position) ? project_employee.position : project_positions[0];

            let position_shifts = (default_position && default_position.shifts) ? default_position.shifts : [];
            let default_shift = (project_employee.position && project_employee.position.shift) ? project_employee.position.shift : position_shifts[0];

            this.setState({
                project_id: project.id,
                project: project,
                positions: project_positions,
                selected_position: default_position,
                position_shifts: position_shifts,
                default_shift: default_shift,
                selected_shift: default_shift,
                shift_id: (default_shift && default_shift.id) ? default_shift.id : '',
            }, () => {
                this.updateTimeByShift(
                    this.state.checkin_time,
                    default_shift
                );

            });
        }

        var default_housings = housings.filter((housing) => {
            if (!helps.isEmpty(housing.employees)) {
                let found_employee = housing.employees.filter((_employee) => {
                    return _employee.value === employee.employee_id;
                })
                if (helps.isEmpty(found_employee)) return false;
                else return true;
            } else {
                return false;
            }
        })
        var default_housing = '';
        if (!helps.isEmpty(default_housings)) {
            default_housing = default_housings[0];
        }

        this.setState({
            check_time: check_time,
            state_text: state_text,
            check_date: curent_date,
            shift_start: shift_start,
            shift_end: shift_end,
            min_date: min_date,
            max_date: max_date,
            default_housing: default_housing,
            housing_id: default_housing.id,
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.checkin_time !== this.state.checkin_time) {
            this.handleFoundCheck();
        }
    }

    handleSubmit(e) {
        e.preventDefault();
        if (this.handleValidation()) {
            var _check = {};
            let selected_position = this.state.selected_position;
            selected_position['shift'] = this.state.selected_shift;
            _check = {
                project_id: this.state.project_id,
                employee_id: this.state.employee_id,
                checked_in: this.state.checked_in,
                checkin_time: this.state.checkin_time,
                checkin_diff: !this.state.is_overtime ? this.state.checkin_diff : 0,
                checked_out: this.state.checked_in,
                checkout_time: this.state.checkout_time,
                note: this.state.note,
                check_date: this.state.checkin_time,
                added_by: this.state.added_by,
                position: selected_position,
                is_overtime: this.state.is_overtime ? true : false,
            }
            var diff = this.state.checkout_time.valueOf() - this.state.checkin_time.valueOf();
            diff = diff / 1000 / 60;
            var diffInM = parseFloat(diff.toFixed(10));
            _check['check_duration'] = diffInM;

            _check['housing_id'] = this.state.housing_id;

            this.props.add(_check);

            this.props.toggleForm();

        } else {
            return false;
        }
    }

    handleChangeTime(value, field) {
        let shift = this.state.selected_shift;

        if (field === 'checkin_time') {

            let check_time = new Date(value);
            let shift_start = shift.start.split(":");
            check_time.setHours(shift_start[0], shift_start[1]);
            let checkin_time = new Date(check_time);
            checkin_time.setHours(shift_start[0], shift_start[1]);
            let checkout_time = new Date(checkin_time);
            checkout_time.setTime(checkin_time.getTime() + (shift.duration * 60 * 60 * 1000));

            this.setState({
                checked_in: 1,
                check_time: check_time,
                checkin_time: check_time,
                checkout_time: checkout_time,
            }, () => { this.updateDuration(checkin_time, checkout_time) });

        } else if (field === 'checkout_time') {
            let checkout_time = value;
            let checkin_time = new Date(this.state.checkin_time);
            checkin_time.setFullYear(checkout_time.getFullYear(), checkout_time.getMonth(), checkout_time.getDate());

            this.setState({
                checked_out: 1,
                check_time: checkin_time,
                checkin_time: checkin_time,
                checkout_time: checkout_time,
            }, () => { this.updateDuration(checkin_time, checkout_time) });
        }
        this.handleFoundCheck();
    }

    handleChange(field, e) {
        const { positions } = this.props;
        let value = e.target.value;
        this.setState({
            [field]: value
        });
        if (field === 'position_id') {
            let position = helps.getItemFromArr(positions, value);
            this.setState({ selected_position: position, position_shifts: position.shifts });
            if (!helps.isEmpty(position.shifts)) {
                let selected_shift = position.shifts[0];
                if (!helps.isEmpty(selected_shift)) {
                    let check_time = new Date(this.state.check_time);
                    let shift_start = selected_shift.start.split(":");
                    check_time.setHours(shift_start[0], shift_start[1]);
                    this.setState({ selected_shift: selected_shift, check_time: check_time }, () => {
                        this.updateTimeByShift(
                            this.state.check_time,
                            selected_shift
                        );

                    });
                }
            }
        }
        if (field === 'shift_id') {
            let shift = helps.getItemFromArr(this.state.selected_position.shifts, value);
            let check_time = new Date(this.state.check_time);
            let shift_start = shift.start.split(":");
            check_time.setHours(shift_start[0], shift_start[1]);
            let checkin_time = new Date(this.state.check_time);
            checkin_time.setHours(shift_start[0], shift_start[1]);
            let checkout_time = new Date(checkin_time);
            checkout_time.setTime(checkin_time.getTime() + (shift.duration * 60 * 60 * 1000));
            this.setState({ selected_shift: shift, shift_id: value, check_time: check_time, checkin_time: checkin_time, checkout_time: checkout_time });
            //console.log(check_time, checkin_time, checkout_time)
        }
        this.handleFoundCheck();
    }

    handleChangeOvertime(e) {
        this.setState({ is_overtime: e.target.checked });
    }

    updateTimeByShift = (date, shift) => {
        if (!shift) return;
        const [hour, minute] =
            shift.start.split(':').map(Number);
        const checkinTime = new Date(date);
        checkinTime.setHours(hour, minute, 0, 0);

        const checkoutTime = new Date(
            checkinTime.getTime() +
            shift.duration * 60 * 60 * 1000
        );

        this.setState({
            checkin_time: checkinTime,
            checkout_time: checkoutTime,
            check_duration: shift.duration
        });
    }

    updateDuration = (checkin_time, checkout_time) => {
        var diff = checkout_time.valueOf() - checkin_time.valueOf();
        diff = diff / 1000 / 60 / 60;

        let check_duration = parseFloat(diff.toFixed(10));
        this.setState({
            check_duration: check_duration
        });
    }


    handleSelectProject(selectedOptions) {
        const { projects, positions } = this.props;
        let project = helps.getItemFromArr(projects, selectedOptions.value);
        let project_positions = positions.filter(position => position.project_id === project.id);
        let default_position = project_positions[0];
        let position_shifts = default_position.shifts;
        let default_shift = position_shifts[0];
        let check_time = new Date(this.state.check_time);
        let checkin_time = new Date(this.state.check_time);
        if (!helps.isEmpty(default_shift)) {
            let shift_start = default_shift.start.split(":");
            checkin_time.setHours(shift_start[0], shift_start[1]);
            let checkout_time = new Date(checkin_time);
            checkout_time.setTime(checkin_time.getTime() + (default_shift.duration * 60 * 60 * 1000));
            this.setState({ check_time: check_time, checkin_time: checkin_time, checkout_time: checkout_time });
        }
        this.setState({
            project_id: selectedOptions.value,
            project: project,
            positions: project_positions,
            selected_position: default_position,
            position_shifts: position_shifts,
            default_shift: default_shift,
            selected_shift: default_shift,
            shift_id: default_shift.id,
        }, () => {

            this.updateTimeByShift(
                this.state.checkin_time,
                default_shift
            );

        });
        this.handleFoundCheck();
        //console.log(default_shift)
    }

    handleFoundCheck = () => {
        const { checks, employee } = this.props;

        const foundCheck = checks.find(check => {
            if (check.employee_id !== employee.employee_id) return false;

            const checkDate = new Date(check.checkin_time);
            const targetDate = new Date(this.state.checkin_time);

            return (
                checkDate.getFullYear() === targetDate.getFullYear() &&
                checkDate.getMonth() === targetDate.getMonth() &&
                checkDate.getDate() === targetDate.getDate()
            );
        });

        this.setState({ found_check: foundCheck });
    };

    alertFoundCheck() {
        const { projects } = this.props;
        let found_check = this.state.found_check;
        let project = helps.getItemFromArr(projects, found_check.project_id);
        return (
            <div>
                <div ><h5 className='font-weight-bold text-danger'>Đã checkin-checkout ngày: {helps.formatDate_from_Timestamp(found_check.checkin_time)}:</h5></div>
                <div>
                    <div><u><i>Mục tiêu: </i></u><b>{project.name}</b></div>
                    <div><u><i>Vị trí: </i></u>{found_check.position.name} {found_check.position.description && <>- {found_check.position.description}</>}</div>
                    <div><u><i>Checkin: </i></u><b>{helps.formatDateTime_from_Timestamp(found_check.checkin_time)}</b> - <u><i>Checkout: </i></u>: <b>{helps.formatDateTime_from_Timestamp(found_check.checkout_time)}</b></div>
                    <div><i><u>Bởi:</u> <b>{found_check.added_by_alias}</b></i></div>
                </div>
            </div>
        );
    }

    handleValidation() {
        let errors = {};
        let formIsValid = true;
        this.setState({ errors: errors });
        return formIsValid;
    }

    render() {
        const { employee, projects, action, show_form, housings } = this.props;

        if (helps.isEmpty(projects) || helps.isEmpty(housings)) {
            return (<></>);
        }

        var position_shifts = this.state.position_shifts;
        var positions = this.state.positions;
        var default_housings = housings.filter((housing) => {
            if (!helps.isEmpty(housing.employees)) {
                let found_employee = housing.employees.filter((_employee) => {
                    return _employee.value === employee.employee_id;
                })
                if (helps.isEmpty(found_employee)) return false;
                else return true;
            } else {
                return false;
            }
        })
        var default_housing = '';
        if (!helps.isEmpty(default_housings)) {
            default_housing = default_housings[0];
        }

        var project_options = [];
        var default_project_option = {};
        if (!helps.isEmpty(projects)) {
            projects.map((project) => {
                if (project.active > 0) {
                    project_options.push({
                        value: project.id,
                        label: project.name,
                    });
                }

            });
        }
        if (!helps.isEmpty(this.state.project)) {
            default_project_option = helps.getItemFromArr(project_options, this.state.project_id, 'value');
        }
        return (
            <CRow>
                <CCol xl={12}>
                    <CForm >
                        <CModal
                            size='xl'
                            show={show_form}
                            onClose={() => this.props.toggleForm()}
                        >
                            <CModalHeader>
                                <h3>
                                    Checkin - Checkout: <b>{employee.fullname}</b> ({employee.employee_id})
                                </h3>
                                <CIcon name="cil-x-circle" className="mfe-1 mt-0 cursor-pointer" onClick={(e) => { this.props.toggleForm() }}></CIcon>
                            </CModalHeader>
                            <CModalBody className='text-left'>
                                <CContainer>
                                    <CRow className='mb-2'>
                                        <CCol md={12}>
                                            <CLabel htmlFor="input-project_id">Mục tiêu:</CLabel>
                                            <Select
                                                id="input-project_id"
                                                placeholder='Mục tiêu ...'
                                                options={project_options}
                                                value={default_project_option}
                                                onChange={(selectedOption) => { this.handleSelectProject(selectedOption) }}
                                            >
                                            </Select>
                                        </CCol>
                                    </CRow>
                                    <CRow className='mb-3'>
                                        <CCol md={6} sm={12}>
                                            <CLabel htmlFor={'position_id'}>Vị trí:</CLabel>
                                            <CSelect
                                                name='position_id'
                                                value={this.state.position_id}
                                                disabled={action === 'checkout'}
                                                onChange={(e) => { this.handleChange('position_id', e) }}
                                            >
                                                {!helps.isEmpty(positions) && positions.length > 0 && positions.map((position) => {
                                                    let position_name = position.name;
                                                    if (!helps.isEmpty(position.description)) {
                                                        position_name = position_name + ' - ' + position.description;
                                                    }
                                                    return (
                                                        <option key={position.id} value={position.id}>{position_name}</option>
                                                    );
                                                })}
                                            </CSelect>
                                        </CCol>
                                        <CCol md={6} sm={12}>
                                            <CLabel htmlFor={'shift_id'}>Ca trực:</CLabel>
                                            <CSelect
                                                name='shift_id'
                                                value={this.state.shift_id}
                                                disabled={action === 'checkout'}
                                                onChange={(e) => { this.handleChange('shift_id', e); }}
                                            >
                                                {!helps.isEmpty(position_shifts) && position_shifts.length > 0 && position_shifts.map((shift) => {
                                                    let shift_name = shift.label;
                                                    shift_name = shift_name + ' - ' + shift.start + '-' + shift.end + '(' + shift.duration + '/24)';
                                                    return (
                                                        <option key={shift.id} value={shift.id}>{shift_name}</option>
                                                    );
                                                })}
                                            </CSelect>
                                        </CCol>
                                    </CRow>
                                    <CRow className='mb-3 mt-1'>
                                        <CCol md={6}>
                                            <div>
                                                <CLabel htmlFor={'checkin_time_' + employee.employee_id}>Thời gian Checkin:</CLabel>
                                                <CFormGroup variant='custom-checkbox' inline>
                                                    <DateTimePicker
                                                        value={this.state.checkin_time}
                                                        format={'dd/MM/yyyy HH:mm'}
                                                        className='font-weight-bold'
                                                        disabled={helps.isEmpty(this.state.selected_shift) ? true : false}
                                                        onChange={(value) => { this.handleChangeTime(value, 'checkin_time') }}
                                                    />
                                                </CFormGroup>
                                            </div>
                                            <div className='mt-1'>
                                                <CLabel htmlFor={'checkout_time_' + employee.employee_id}>Thời gian Checkout:</CLabel>
                                                <CFormGroup variant='custom-checkbox' inline>
                                                    <DateTimePicker
                                                        value={this.state.checkout_time}
                                                        format={'dd/MM/yyyy HH:mm'}
                                                        className='font-weight-bold'
                                                        disabled={helps.isEmpty(this.state.selected_shift) ? true : false}
                                                        onChange={(value) => { this.handleChangeTime(value, 'checkout_time') }}
                                                    />
                                                    {this.state.check_duration > 0 && <span className='ml-3 mt-2 font-weight-bold text-danger'><i>({this.state.check_duration} giờ)</i></span>}
                                                </CFormGroup>
                                            </div>
                                        </CCol>
                                        <CCol md={6}>
                                            {!helps.isEmpty(this.state.found_check) && this.alertFoundCheck()}
                                        </CCol>
                                    </CRow>
                                    <CRow className='mb-2'>
                                        <CCol md={12}>
                                            <CLabel htmlFor="input-is_overtime">Tăng ca?:</CLabel>
                                            <CFormGroup variant="custom-radio" inline>
                                                <CInputCheckbox
                                                    type="checkbox"
                                                    name="is_overtime"
                                                    id="input-is_overtime"
                                                    title='Tăng ca ?'
                                                    className='mt-2 cursor-pointer'
                                                    checked={this.state.is_overtime}
                                                    value={1}
                                                    onChange={(e) => { this.handleChangeOvertime(e) }}

                                                />
                                            </CFormGroup>
                                        </CCol>
                                    </CRow>
                                    <CRow className='mb-2'>
                                        <CCol md={12}>
                                            <CLabel htmlFor='housing_id'>Nhà Đội:</CLabel>
                                            <CFormGroup variant='custom-checkbox' inline>
                                                <CSelect
                                                    id='housing_id'
                                                    defaultValue={default_housing.id}
                                                    onChange={(e) => { this.handleChange('housing_id', e) }}
                                                >
                                                    <option value=''> - không - </option>
                                                    {!helps.isEmpty(housings) && housings.map((housing) => {
                                                        return (
                                                            <option key={'housing-' + housing.id} value={housing.id}>{housing.name}</option>
                                                        );
                                                    })}
                                                </CSelect>
                                            </CFormGroup>
                                        </CCol>
                                    </CRow>
                                    <CRow className='mb-3'>
                                        <CCol md={12}>
                                            <CLabel htmlFor='note'>Ghi chú:</CLabel>
                                            <CTextarea
                                                rows={4}
                                                name="note"
                                                id="note"
                                                defaultValue={this.state.content}
                                                onChange={(e) => { this.handleChange('note', e) }}
                                            >
                                            </CTextarea>
                                        </CCol>
                                    </CRow>
                                </CContainer>
                            </CModalBody>
                            <CModalFooter>
                                <CContainer>
                                    <CRow>
                                        <CCol cols={6}>
                                            <CTooltip content={"Check"}>
                                                <CButton type="submit" size='sm' color={"primary"} onClick={(e) => this.handleSubmit(e)}>
                                                    <CIcon name="cil-save" className="mfe-1 mt-0"></CIcon>
                                                    Check
                                                </CButton>
                                            </CTooltip>
                                        </CCol>
                                        <CCol cols={6} className={'text-right'}>
                                            <CButton type="button" size='sm' color="secondary" onClick={(e) => { this.props.toggleForm() }} className="ml-3">
                                                <CIcon name="cil-x-circle" className="mfe-1 mt-0"></CIcon>
                                                Huỷ
                                            </CButton>
                                        </CCol>
                                    </CRow>
                                </CContainer>
                            </CModalFooter>
                        </CModal>
                    </CForm>
                </CCol>
            </CRow>
        )
    }
}
export default EmployeeCheckForm;

